import { CompilationResult } from '../../hooks/useLatexCompiler';
import { ProjectFile } from '../../types';
import { ProjectZipAdditionalEntry } from '../../utils/projectZip';
import { getCompileTargetFile } from './compileTargets';

interface BuildProjectZipAdditionalEntriesOptions {
  activeFile: ProjectFile | null;
  canCompile: boolean;
  canEdit: boolean;
  files: ProjectFile[];
  flushSave: () => Promise<unknown>;
  validateCompile: (
    texContent: string,
    allFiles: ProjectFile[]
  ) => Promise<CompilationResult>;
}

export async function buildProjectZipAdditionalEntries({
  activeFile,
  canCompile,
  canEdit,
  files,
  flushSave,
  validateCompile,
}: BuildProjectZipAdditionalEntriesOptions): Promise<ProjectZipAdditionalEntry[]> {
  if (!canCompile) {
    return [];
  }

  if (canEdit) {
    try {
      await flushSave();
    } catch {
      // Continue with the current in-memory files and skip surfacing an error.
    }
  }

  const texFile = getCompileTargetFile(files, activeFile);
  if (!texFile) {
    return [];
  }

  try {
    const compilationResult = await validateCompile(texFile.content, files);
    if (!compilationResult.pdf || compilationResult.pdf.byteLength === 0) {
      return [];
    }

    return [{ path: 'problem.pdf', bytes: compilationResult.pdf }];
  } catch {
    return [];
  }
}
